import Vue from "vue";

Vue.component("InputComponent", () => import("./components/element/InputComponent.vue"));
Vue.component("ButtonStyle", () => import("./components/element/ButtonStyle.vue"));
Vue.component("ButtonDropdown", () => import("./components/element/ButtonDropdown.vue"));
Vue.component("InputDropdown", () => import("./components/element/InputDropdown.vue"));
Vue.component("InputCitizenId", () => import("./components/element/InputCitizenId.vue"));
Vue.component("InputMerchantSocialSecurityID", () => import("./components/element/InputMerchantSocialSecurityID.vue"));
Vue.component("InputBranchSocialSecurityID", () => import("./components/element/InputBranchSocialSecurityID.vue"));
Vue.component("InputBranchMerchant", () => import("./components/element/InputBranchMerchant.vue"));
Vue.component("InputStatementPasscode", () => import("./components/element/InputStatementPasscode.vue"));
Vue.component("ActionDropdownIconMenu", () => import("./components/element/ActionDropdownIconMenu.vue"));
Vue.component("ThailandAddressAutocomplete", () => import("./components/element/ThailandAddressAutocomplete.vue"));
Vue.component("Tooltip", () => import("./components/element/Tooltip.vue"));
Vue.component("SwitchComponent", () => import("./components/element/SwitchComponent.vue"));
Vue.component("ModalBox", () => import("./components/modal/ModalBox.vue"));
Vue.component("Radio", () => import("./components/element/Radio.vue"));
Vue.component("CheckBox", () => import("./components/element/CheckBox.vue"));
Vue.component("CalendarSinglePicker", () => import("./components/calendar/CalendarSinglePicker.vue"));
Vue.component("CalendarMonthandyear", () => import("./components/calendar/CalendarMonthandyear.vue"));
Vue.component("Skeleton", () => import("./components/element/Skeleton.vue"));
Vue.component("TableBox", () => import("./components/table/TableBox.vue"));
Vue.component("SortButton", () => import("./components/table/SortButton.vue"));
Vue.component("DragAndDropFile", () => import("./components/element/DragAndDropFile.vue"));
Vue.component("TextArea", () => import("./components/element/TextArea.vue"));
